module.exports = __webpack_public_path__ + "img/mastercard.1a7f6653.svg";